export const ENERGY_CLASS_LABEL_TYPE = 4;

export const ENERGY_CLASS_VALUE_HASH = "EURONICS_ENERGY_CLASS_VALUE";
export const ENERGY_CLASS_LABEL_HASH = "EURONICS_ENERGY_CLASS_LABEL";
export const ENERGY_CLASS_SHEET_HASH = "EURONICS_ENERGY_CLASS_SHEET";

export const PRODUCT_PARAMETER_BLACKLIST = [
  ENERGY_CLASS_LABEL_HASH,
  ENERGY_CLASS_SHEET_HASH,
];

/* keep synced with next.config.js rewrites */
export const EXTERNAL_FILES_DOMAIN = "https://sub3.tpd.sk";
export const EXTERNAL_IMAGES_DOMAIN = "https://images.tpd.sk";